import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoLoader } from "@/components/LogoLoader";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <LogoLoader />;
  }
  if (!user) return <Navigate to="/join" replace />;
  return children;
}
